var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2915 4.61375V13.4583H8.70817V4.61375L6.1408 7.18113L5.02138 6.06171L9.49984 1.58325L13.9783 6.06171L12.8589 7.18113L10.2915 4.61375ZM3.1665 12.6666H4.74984V15.8333H14.2498V12.6666H15.8332V15.8333C15.8332 16.7041 15.1207 17.4166 14.2498 17.4166H4.74984C3.879 17.4166 3.1665 16.6542 3.1665 15.8333V12.6666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/exportIcon.44205ad01c8a567324329d5b3310420b.svg";
export { ForwardRef as ReactComponent };